import React from "react";
import ImageSection from "../Footer/RightSection";

import { CheckIcon, SubTitle, Title, Wrapper } from "./style";

function CTASuccessView() {
  return (
    <Wrapper
      id="requestCallbackSuccessModal"
      className="callback-message-wrapper"
      aria-labelledby="requestCallbackSuccessModal"
    >
      <CheckIcon icon="icon-how-it-work-check" />
      <Title variant="heading2">Callback requested</Title>
      <SubTitle variant="paragraph1">Thanks, we will call you back!</SubTitle>
      <ImageSection isCTAFormView={true} />
    </Wrapper>
  );
}

export default CTASuccessView;
